import React from "react";
import styled from "styled-components/macro";
import { DefaultText, HoverableText, smallShadow } from "theme/GlobalElements";
import DropdownItem from "components/Dropdown/DropdownItem";
import { Link, useLocation } from "react-router-dom";
import { RootState } from "store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { selectMenuItems } from "features/header/headerSlice";
import { useNavigate } from "react-router-dom";
import { MenuItem } from "features/header/types";
import BrandsDropdown from "components/Dropdown/BrandsDropdown";

interface BottomSectionProps {}

const BottomSection: React.FC<BottomSectionProps> = () => {
  const menuItems = useSelector((state: RootState) => selectMenuItems(state));
  const navigate = useNavigate();
  const navigateTo = (route: string) => {
    navigate(route ?? "/");
  };

  const renderDropDown = (item: MenuItem, idx: number) => {
    if (item.data.length === 0) {
      return (
        <Menu key={idx} to={item.route ?? "/"}>
          <HoverableText className="text-body" title={item.title} color="white">
            {item.title}
          </HoverableText>
        </Menu>
      );
    } else {
      if (item.name === "brand") {
        return <BrandsDropdown key={idx} item={item} />;
      } else {
        return (
          <DropdownItem key={idx} title={item.title}>
            {item.data.map((i, idx) => {
              return (
                <Element key={idx} to={i.route ?? "/"}>
                  <Text className="text-sm">{i.title}</Text>
                </Element>
              );
            })}
          </DropdownItem>
        );
      }
    }
  };

  const renderSection = () => {
    // if (isHomePage) {
    //   return (
    //     <>
    //       <BrandsTitle>
    //         <DefaultText fontSize={18} color="white">
    //           Водещи марки
    //         </DefaultText>
    //       </BrandsTitle>
    //       <InnerContainer>
    //         {menuItems &&
    //           menuItems.length !== 0 &&
    //           menuItems.map((item, idx) => {
    //             return (
    //               item.title !== "Водещи марки" && renderDropDown(item, idx)
    //             );
    //           })}
    //       </InnerContainer>
    //     </>
    //   );
    // } else {
    return (
      <InnerContainer>
        {menuItems &&
          menuItems.length !== 0 &&
          menuItems.map((item: MenuItem, idx: number) => {
            return renderDropDown(item, idx);
          })}
      </InnerContainer>
    );
    // }
  };
  return <BottomSectionContainer>{renderSection()}</BottomSectionContainer>;
};

const BottomSectionContainer = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: flex-start;
  padding: 10px 0;
`;
const Menu = styled(Link)`
  text-decoration: none;
  cursor: pointer;
  padding-right: 20px;
  align-self: end;
`;
const BrandsTitle = styled.div`
  width: 200px;
`;

const InnerContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;
const Element = styled(Link)`
  text-decoration: none;
  cursor: pointer;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 5px 10px 5px 10px;

  &:hover {
    background-color: white;
    /* font-weight: 600; */
    transform: scale(1.05);
    transition: 0.2s;
    ${smallShadow};
  }
`;

const Text = styled.span`
  color: black;
  cursor: pointer;
  white-space: nowrap;
  /* & + & {
    margin-top: 4px;
  } */
`;
export default BottomSection;
